import React from 'react';
import { Target, Users, Lightbulb, Globe } from 'lucide-react';
import { companyInfo } from '../data/mock';

const AboutSection = ({ id }) => {
  const features = [
    {
      icon: <Target size={24} />,
      title: "Metodologias Comprovadas",
      description: "Design Thinking, Human-Centered Design e UX Research para soluções inovadoras"
    },
    {
      icon: <Users size={24} />,
      title: "Equipe Multi­disciplinar",
      description: "Profissionais especializados em design digital e industrial trabalhando em sinergia"
    },
    {
      icon: <Lightbulb size={24} />,
      title: "Inovação Constante",
      description: "Transformação de ideias em produtos que elevam e funcionam de verdade"
    },
    {
      icon: <Globe size={24} />,
      title: "Atendimento Híbrido",
      description: "Online completo para todo o Brasil, presencial quando necessário"
    }
  ];

  return (
    <section id={id} className="section-padding bg-gradient-to-b from-bg-page to-bg-card/30">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16 fade-in-up">
          <div className="inline-flex items-center gap-2 glass-card px-4 py-2 text-sm text-brand-primary border border-brand-primary/20 mb-6">
            <span>Sobre nós</span>
          </div>
          <h2 className="heading-1 mb-6">
            <span className="text-brand-primary">Manch</span> Studios
          </h2>
          <div className="w-20 h-1 bg-brand-primary rounded-full mx-auto mb-8"></div>
          <p className="body-large max-w-3xl mx-auto">
            {companyInfo.fullDescription}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="glass-card p-6 text-center hover:border-brand-primary/30 transition-all duration-300"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-16 h-16 bg-brand-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 border border-brand-primary/20">
                <div className="text-brand-primary">
                  {feature.icon}
                </div>
              </div>
              <h3 className="text-sm lg:card-title-small mb-3 leading-tight px-4 font-semibold break-words text-center">{feature.title}</h3>
              <p className="body-small px-3">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Vision Statement */}
        <div className="glass-card p-8 lg:p-12 text-center">
          <div className="max-w-4xl mx-auto">
            <h3 className="heading-2 text-2xl lg:text-3xl mb-6">
              “O design é a ponte entre a <span className="text-brand-primary">inovação</span> e as pessoas"
            </h3>
            <p className="body-medium">
              Nossa missão é criar experiências que conectam tecnologia e humanidade, 
              desenvolvendo produtos que não apenas funcionam, mas encantam e transformam a vida das pessoas.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;